import { render, staticRenderFns } from "./AffiliatedRegister.vue?vue&type=template&id=0d7631c8&"
import script from "./AffiliatedRegister.vue?vue&type=script&lang=ts&"
export * from "./AffiliatedRegister.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports